import { Controller } from 'stimulus';
import consumer from '../channels/consumer';

export default class extends Controller {
  connect() {
    console.log('loading channel in cable-controller', this.subscriptionData);
    this.consumer = consumer.subscriptions.create(
      this.subscriptionData,
      {
        received: this.received.bind(this),
      },
    );
  }

  disconnect() {
    this.consumer.unsubscribe();
  }

  received(data) {
    console.log(data, this.channel);
  }

  get subscriptionData() {
    return {
      channel: this.channel,
      id: this.id,
    };
  }

  get channel() {
    return this.data.get('channel');
  }

  get id() {
    return this.data.get('id');
  }
}
